export const LogoMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <path d="M42 4a28 28 0 1 0 0 56 34 34 0 0 1 0-56z" fill="#bfa15f" />
    <path d="M47 19l2.8 7.2L57 29l-7.2 2.8L47 39l-2.8-7.2L37 29l7.2-2.8z" fill="#F4F4F5" />
  </svg>
);

export default function Logo({ size = 26, withText = true }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <LogoMark size={size} />
      {withText && (
        <span className="font-display text-2xl tracking-tight text-paper">
          moon<span className="italic text-gold">spirit</span>vida
        </span>
      )}
    </span>
  );
}
